import React from "react";

const GymAdmin = ({ children }) => {
  return <div>{children}</div>;
};

export default GymAdmin;
